<template>
  <div class="action-bar">
    <Button @click="generatePDF">
      Generate PDF
    </Button>
    <Dropdown
      v-model="selectedStyle"
      :options="styles"
      option-label="name"
      @change="updateStyle"
    />
  </div>

  <div
    ref="quoteContent"
    class="quote-container"
  >
    <!-- Header with Logo and Quotation Label -->
    <div class="header flex justify-between items-center">
      <img
        :src="Logo"
        alt="Symphony Logo"
        class="logo"
      >
      <div
        class="quote-box"
        :style="{ backgroundColor: mainColour, color: tableFontColour }"
      >
        PREP LIST: XYZ JOB
      </div>
    </div>

    <!-- Invoice and Customer Information -->
    <div class="info-section">
      <h2 class="section-title">
        Job Information
      </h2>
      <table class="info-section-table">
        <tbody>
          <tr>
            <td
              colspan="2"
              class="header-cell"
            >
              Job Number:
            </td>
            <td
              colspan="2"
              class="content-cell"
            >
              343432
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              class="header-cell"
            >
              Project Manager:
            </td>
            <td
              colspan="2"
              class="content-cell"
            >
              Joe Blogs
            </td>
          </tr>
          <tr>
            <td class="header-cell">
              Date Out:
            </td>
            <td class="content-cell">
              25/11/2024
            </td>
            <td class="header-cell">
              Time Out:
            </td>
            <td class="content-cell">
              18:00
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Product Details Table -->
    <h2 class="section-title">
      Picking List
    </h2>
    <table class="picking-table">
      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="index"
        >
          <td>
            <div class="tick-box">
              Prep
            </div>
          </td>
          <td>
            <div class="tick-box">
              Load
            </div>
          </td>
          <td class="product-info">
            {{ item.qty }} x {{ item.product }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Logo from '@/assets/logos/Symphony_Logo_Vertical_RGB.png';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const quoteContent = ref(null);
const mainColour = ref('#ffcc00');
const tableFontColour = ref('black');

const updateStyle = (event) => {
    mainColour.value = event.value.mainCol
    tableFontColour.value = event.value.tableFontCol
}

const styles = ref([
    { name: 'Yellow', mainCol: '#ffcc00', tableCol: 'grey', tableFontCol: 'black' },
    { name: 'Orange', mainCol: 'orange', tableCol: 'grey', tableFontCol: 'black' },
    { name: 'Blue', mainCol: 'blue', tableCol: 'grey', tableFontCol: 'white' },
    { name: 'Black', mainCol: 'black', tableCol: 'black', tableFontCol: 'white' },
]);

const items = ref([
    { product: 'Product A', qty: 50 },
    { product: 'Product B', qty: 70 },
    { product: 'Product C', qty: 80 },
    { product: 'Product D', qty: 50 },
    { product: 'Product E', qty: 70 },
]);

const generatePDF = async () => {
    const content = quoteContent.value;
    const canvas = await html2canvas(content, { scale: 2 }); // Increase scale for better resolution
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('prep-list.pdf');
};
</script>

<style scoped>
.action-bar {
    width: 210mm;
    margin: 0 auto 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.section-title {
    font-size: 1.2em;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #333;
    border-bottom: 1px solid #ddd;
}

.quote-container {
    width: 210mm;
    height: 297mm;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
    background-color: #f9f9f9;
    border: 1px solid #e0e0e0;
}

.header {
    margin-bottom: 20px;
}

.logo {
    width: 50mm;
}

.quote-box {
    position: absolute;
    right: 65mm;
    top: 30mm;
    color: #000;
    width: 25%;
    font-weight: bold;
    padding: 10px;
    font-size: 18px;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.info-section-table {
    width: 50%;
    /* Set width of Job Information table */
    border-collapse: collapse;
    margin-bottom: 20px;
}

.picking-table {
    width: 100%;
    /* Set width of Picking List table */
    border-collapse: collapse;
    margin-bottom: 20px;
}

.info-section-table td,
.picking-table td {
    padding: 8px;
}

.tick-box {
    display: inline-block;
    width: 15mm;
    height: 15mm;
    border: 1px solid grey;
    border-radius: 3px;
    text-align: center;
    line-height: 15mm;
    font-size: small;
    color: grey;
    margin: 5px;
}

.product-info {
    font-weight: 600;
    font-size: 1em;
    color: #333;
}
</style>
